/* Localize the app's real trigger without replacing its focus, menu or events. */
(() => {
  const observed = new WeakSet();
  function enhance() {
    document.querySelectorAll('.bm-transtore-header[data-bm-switcher-label], .bm-transtore-footer[data-bm-switcher-label]').forEach(host => {
      if (observed.has(host)) return;
      observed.add(host);
      const label = host.dataset.bmSwitcherLabel;
      const update = () => {
        host.querySelectorAll('.ts-switcher-btn[role="button"]').forEach(button => {
          const names = [...new Set([...button.querySelectorAll('.ts-switcher-btn__name')].map(el => el.textContent.trim()).filter(Boolean))];
          const text = label + (names.length ? ': ' + names.join(' · ') : '');
          if (button.getAttribute('aria-label') !== text) button.setAttribute('aria-label', text);
          if (button.getAttribute('title') !== text) button.setAttribute('title', text);
        });
      };
      update();
      new MutationObserver(update).observe(host, {childList: true, subtree: true, characterData: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
